import React, { useState, useEffect } from 'react';

const WaveformSVG = ({ data, width = 150, height = 40, mode = 2, text }) => {
  const [waveData, setWaveData] = useState(data);
  const colorId = "grad" + mode;
  const generateWavePath = (data) => {
    let start = data[0], end = data[data.length - 1];
    let path = `M 0 ${start}`;
    const maxValue = Math.max.apply(null, data);
    data.forEach((point, index) => {
      const x = index * 10;
      const y = 40 * (1 - point / maxValue);
      path += ` L ${x} ${y}`;
    });
    path += `L ${width} ${end}`
    return path;
  };

  const wavePath = generateWavePath(waveData);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{stopColor:'rgb(43, 152, 82)',stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'rgb(43, 214, 106)', stopOpacity:1}} />
        </linearGradient>
        <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{stopColor:'rgb(61, 117, 213)',stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'rgb(122, 160, 237)', stopOpacity:1}} />
        </linearGradient>
      </defs>
      <path
        d={`${wavePath} L ${width} ${height} L 0 ${height} Z`}
        fill={`url(#${colorId})`}
      />
      <text
          x="50%" 
          y="30"
          textAnchor="middle"
          fontSize="15"
          fill="#333"
        >
          {text}
        </text>
    </svg>
  );
};

export default WaveformSVG;
